/***
 *
 *   SIGN UP STEP 1
 *   Signup form for account owners
 *   Step 1: create account
 *   Step 2: select plan and make payment
 *
 **********/

import React, { useContext } from "react";
import {
  AuthContext,
  Animate,
  Row,
  Card,
  SocialSignin,
  Form,
  Link,
  NewLookNotice,
} from "components/lib";
import logoImg from "../../../assets/StackGo_Logo.png";
import { Helmet } from "react-helmet";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import "./account.scss";
const Settings = require("settings.json");
const recaptchaV3SiteKey = Settings[process.env.NODE_ENV].recaptcha.site_key;

export function Signup(props) {
  const context = useContext(AuthContext);

  return (
    <Animate type="pop">
      <Helmet>
        <meta
          name="description"
          content="Create your free StackGo account to get started. Identity Checks Anywhere."
        ></meta>
        <meta name="title" content="Sign Up for StackGo"></meta>
      </Helmet>
      <Row title="Create Your Account" color="transparent">
        <div className="img-wrapper">
          {/* <img src={logoImg} className='img-logo' alt=''/> */}
        </div>
        <Card loading={false} restrictWidth center>
          <SocialSignin network={["facebook", "twitter"]} showOr signup />
          <div>
            <div>
              <GoogleReCaptchaProvider reCaptchaKey={recaptchaV3SiteKey}>
              <Form
                data={{
                  name: {
                    label: "First Name",
                    type: "text",
                    required: true,
                    errorMessage: "Please enter your first name",
                  },
                  email: {
                    label: (
                      <label id="emailLabel">
                        Work Email
                        <label id="warningLabel" className="info hidden">
                          {" "}
                          (please provide your work email address)
                        </label>
                      </label>
                    ),
                    type: "email",
                    required: true,
                  },
                  password: {
                    label: "Password",
                    type: "password",
                    required: true,
                    complexPassword: true,
                  },
                  confirm_password: {
                    type: "hidden",
                    value: null,
                  },
                }}
                url="/api/account"
                method="POST"
                buttonText="Create Account"
                callback={context.signin}
                updateOnChange={true}
                recaptcha={true}
                onChange= {({input, value, valid}) => {
                  const warningEl = document.getElementById("warningLabel");
                  // console.log(input, value, valid);
                  if (input === "email") {
                    const val = value.toLowerCase();
                    const notAllowed = ["@hotmail", "@outlook", "@live", "@msn", "@yahoo", "@gmail", "@icloud", "@aol", "@mail", "@protonmail", "@zoho"];
                    if (notAllowed.some((domain) => val.includes(domain))) {
                      warningEl.classList.remove("hidden");
                    } else {
                      warningEl.classList.add("hidden");
                    }
                  } 
                }
                }
              />
              </GoogleReCaptchaProvider>
              <div>
                <p>
                  Already registered? <Link url="/signin" text="Sign In" />
                </p>
              </div>
            </div>
            {/* <div className="col-start-5 col-span-2 gap-4 text-justify">
              <br />
              <h3>Why StackGo?</h3>
              <ul>
                <li>
                  🚀 <strong>Quick </strong>- installs in 5 minutes.
                </li>
                <li>
                  😌 <strong>Frictionless</strong> - takes 30 seconds for end
                  customers, no data entry.
                </li>
                <li>
                  {" "}
                  🦾 <strong>Automated</strong> - zero manual effort for your
                  team.
                </li>
                <li>
                  🔒 <strong>Secure</strong> - private storage of identity
                  documents.
                </li>
                <li>
                  🌎 <strong>Global</strong> - 10k+ document types from 200+
                  countries.
                </li>
                <li>
                  😀 <strong>Affordable</strong> - free to try, then
                  pay-as-you-go.
                </li>
                <li>
                  🧩 <strong>Integrated</strong> - works with HubSpot, Xero, and
                  more.
                </li>
              </ul>
            </div> */}
          </div>

          <div className="mt-4"></div>
        </Card>

        <NewLookNotice className="mt-10" />
      </Row>
    </Animate>
  );
}
